// Mirrors the header options every Stack.Screen repeats in the mobile app's
// navigator (title, back button, "home" icon navigating to MyCases).
// showBack uses browser back (navigate(-1)) to match React Navigation's
// goBack() semantics (returns to whatever screen the user actually came from).
const ROUTES = [
  { pattern: /^\/m\/login$/, title: 'LegalApp', showBack: false, showHome: false },
  { pattern: /^\/m\/register$/, title: 'Register', showBack: true, showHome: false },
  { pattern: /^\/m\/reset-password$/, title: 'Reset Password', showBack: true, showHome: false },
  { pattern: /^\/m\/about$/, title: 'About Us', showBack: true, showHome: false },
  { pattern: /^\/m\/text\//, title: null, showBack: true, showHome: true },
  { pattern: /^\/m\/language$/, title: 'Language', showBack: true, showHome: true },
  { pattern: /^\/m\/state$/, title: 'State', showBack: true, showHome: true },

  { pattern: /^\/m\/cases$/, title: 'Case List', showBack: false, showHome: false },
  { pattern: /^\/m\/cases\/details$/, title: 'Case Details', showBack: true, showHome: true },
  { pattern: /^\/m\/cases\/share$/, title: 'Share Case', showBack: true, showHome: true },
  { pattern: /^\/m\/cases\/new$/, title: 'New FIR', showBack: true, showHome: true },
  { pattern: /^\/m\/profile$/, title: 'Profile', showBack: true, showHome: true },

  { pattern: /^\/m\/fir\/dashboard$/, title: 'Case Dashboard', showBack: true, showHome: true },
  { pattern: /^\/m\/fir\/timeline$/, title: 'Case Brief', showBack: true, showHome: true },
  { pattern: /^\/m\/fir\/tasks$/, title: 'SOPs', showBack: true, showHome: true },
  { pattern: /^\/m\/fir\/evidences$/, title: 'Evidences', showBack: true, showHome: true },
  { pattern: /^\/m\/fir\/witnesses\/questions$/, title: 'Questions', showBack: true, showHome: true },
  { pattern: /^\/m\/fir\/witnesses$/, title: 'Witnesses', showBack: true, showHome: true },
  { pattern: /^\/m\/fir\/accused$/, title: 'Accused', showBack: true, showHome: true },
  { pattern: /^\/m\/fir\/statements\/view$/, title: 'Statement', showBack: true, showHome: true },
  { pattern: /^\/m\/fir\/statements\/dashboard$/, title: 'Statement Dashboard', showBack: true, showHome: true },
  { pattern: /^\/m\/fir\/statements\/new$/, title: 'New Statement', showBack: true, showHome: true },
  { pattern: /^\/m\/fir\/statements$/, title: 'Statements', showBack: true, showHome: true },
  { pattern: /^\/m\/fir\/discrepancies$/, title: 'Discrepancies', showBack: true, showHome: true },
  { pattern: /^\/m\/fir\/casediary\/new$/, title: 'Case Diary', showBack: true, showHome: true },
  { pattern: /^\/m\/fir\/chargesheet\/new$/, title: 'Charge Sheet', showBack: true, showHome: true },
  { pattern: /^\/m\/fir\/chargesheet\/generated$/, title: 'Generated Charge Sheet', showBack: true, showHome: true },
  { pattern: /^\/m\/fir\/chargesheet\/verified$/, title: 'Verified Charge Sheet', showBack: true, showHome: true },
  { pattern: /^\/m\/fir\/chargesheet$/, title: 'Charge Sheet', showBack: true, showHome: true },
];

const DEFAULT_META = { title: '', showBack: true, showHome: true };

export function getRouteMeta(pathname) {
  const match = ROUTES.find((r) => r.pattern.test(pathname));
  return match || DEFAULT_META;
}
